export { default } from './toPairsIn.js'



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/entriesIn.js
// module id = 231
// module chunks = 0